import { memo } from 'react';
import classNames from 'classnames';

import { UiKitButton } from 'src/components/common/ui-kit-button';
import { FormattedMessage } from '@features/intl';
import { TimerDisplay } from './timer-display';
import { useOptimizedCountdown } from '@utils/hooks/use-optimized-countdown';

import styles from '../index.module.css';

type DefaultBannerProps = {
  onClick?: () => void;
  onFinish?: () => void;
  targetTime: number;
  className?: string;
};

export const DefaultBanner = memo(
  ({ onClick, onFinish, targetTime, className }: DefaultBannerProps) => {
    const { minutes, seconds, isComplete } = useOptimizedCountdown({
      targetDate: targetTime,
      onComplete: onFinish,
    });

    return (
      <div className={classNames(styles.banner, className)}>
        <div
          className={classNames(styles.timer, isComplete && styles.timerEnd)}
        >
          {isComplete ? (
            <FormattedMessage
              defaultMessage="Personal discount is still available to you!"
              id="Onboarding.Paywall.Discount.Personal"
            />
          ) : (
            <>
              <p>
                <FormattedMessage
                  defaultMessage="Discount available:"
                  id="Onboarding.Paywall.Discount.Available"
                />
              </p>
              <TimerDisplay
                minutes={minutes}
                seconds={seconds}
                isTimerEnd={isComplete}
              />
            </>
          )}
        </div>
        <UiKitButton size="sm" onClick={onClick} className={styles.linkButton}>
          <FormattedMessage
            defaultMessage="GET MY PLAN"
            id="Onboarding.Purchase.ButtonPlan"
          />
        </UiKitButton>
      </div>
    );
  },
);

DefaultBanner.displayName = 'DefaultBanner';
